import PageHeader from "components/layout/PageHeader";
import { Header } from "../components/header";
import { Stack } from "@chakra-ui/react";
import { StatementsTable } from "../components/tables/statements-table";

export function Statements() {
  return (
    <>
      <PageHeader title="Statements" />

      <Stack gap={4}>
        <Header />
        <StatementsTable />
      </Stack>
    </>
  );
}
